import Agendamento from '../../Components/Banner-Agendamentos/BanAgendamentos';
import Footer from '../../Components/Footer/Footer';
import PoliticaPrivacidade from '../../Components/Privacidade/Privacidade';

function Privacidade() {
    return (
        <>
            <div id="PrivacidadeMain">
                <PoliticaPrivacidade />
            </div>
            <div id="Agendamento">
                <Agendamento/>
            </div>
           <div id="Footer">
                <Footer />
            </div>
        </>
    );
}

export default Privacidade;